/* eslint-disable import/no-anonymous-default-export */
import { ENDPOINT, HTTP } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

/**
 * 
 * @param {string} userId 
 * @param {(docId, updates) => void} updateDocumentState 
 */
export default async function (userId, filename, updateDocumentState) {
  try {
    // Fetch the SAS URL from the server
    const downloadResponse = await fetchFromLawfeed({
      method: HTTP.GET,
      endpoint: ENDPOINT.DOCUMENTS_DOWNLOAD,
      routeParams: [userId, filename]
    });

    if (!downloadResponse || !downloadResponse.sasUrl) {
      throw new Error('Failed to get download URL');
    }

    // abre pestaña con el SAS URL
    window.open(downloadResponse.sasUrl, '_blank');
    return false;
  } catch (error) {
    console.error("Error downloading document:", error);
    return true;
  }
}